import PayMeCooperationFrom from './PayMeCooperationFrom';

export default PayMeCooperationFrom;
